export default class AdvertisingBannerService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('advertisingBanners/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('advertisingBanners', params)
	}

	createEntity(params) {
		return this.apiService.callPost('advertisingBanners', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('advertisingBanners/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('advertisingBanners/' + id, params)
	}

	getRecipients(params){
		return this.apiService.callGet('advertisingBanners/getRecipients', params)
	}

	getQRCode(params){
		return this.apiService.callGet('advertisingBanners/getQRCode', params)
	}

}



// WEBPACK FOOTER //
// ./src/service/AdvertisingBannerService.js